var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserLayout',{ref:"orderLayout",attrs:{"pageTitle":"Gestione ordini"},scopedSlots:_vm._u([{key:"page-content",fn:function(props){return [_c('FrmManageOrders')]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }